module.exports = __webpack_public_path__ + "static/media/undercover4.7f9e6d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/undercover4.png
// module id = 178
// module chunks = 0